var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBounceEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15166_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8887 3C17.5959 3 18.2743 3.28115 18.7744 3.78125C19.2741 4.28119 19.5555 4.95917 19.5557 5.66602V9.66602C19.5553 10.1566 19.1567 10.5557 18.666 10.5557C18.1756 10.5553 17.7777 10.1564 17.7773 9.66602V5.66602C17.7772 5.43067 17.6838 5.20463 17.5176 5.03809C17.3509 4.87139 17.1244 4.77734 16.8887 4.77734H2.66602C2.43049 4.7775 2.20464 4.87153 2.03809 5.03809C1.87175 5.20464 1.77746 5.43062 1.77734 5.66602V16.333C1.77771 16.8194 2.17965 17.2213 2.66602 17.2217H13.7773C14.2683 17.2217 14.666 17.6204 14.666 18.1113C14.6654 18.6017 14.2679 19 13.7773 19H2.66602C1.19782 18.9997 0.0003662 17.8012 0 16.333V5.66602C0.000114931 4.95913 0.281519 4.2812 0.78125 3.78125C1.2812 3.2813 1.95899 3.00016 2.66602 3H16.8887Z",
    fill: "#2783EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 6.55469L10.6932 11.6214C10.4188 11.7933 10.1015 11.8845 9.77768 11.8845C9.45385 11.8845 9.13655 11.7933 8.86213 11.6214L0.888794 6.55469",
    stroke: "#2783EC",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 12.7773V15.0012",
    stroke: "#2783EC",
    strokeWidth: 1.40596,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 17.2227V17.2278",
    stroke: "#2783EC",
    strokeWidth: 1.77775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.2222,
    cy: 15.0004,
    r: 4.95238,
    stroke: "#2783EC",
    strokeWidth: 1.65079
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15166_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBounceEmail);
export default __webpack_public_path__ + "static/media/icon-bounce-email.a25823ed4232292928ca169d3b2c68cf.svg";
export { ForwardRef as ReactComponent };